export const isLocal = window.location.host.includes("localhost");